export const BUTTON_NAMES = {
  authorize: 'Авторизоваться',
  cancel: 'Отмена',
  signUp: 'Оформить подписку',
  continueWithoutRegistration: 'Продолжить без подписки',
  backToSingUpStart: 'Вернуться к началу',
  navigateToprofile: 'Перейти в Личный кабинет',
  navigateBack: 'Вернуться к работе',
  continueSignUp: 'Продолжить оформление',
  cancelSignUp: 'Отменить оформление',
  acceptAnalyticsCookies: 'Принять',
  rejectAnalyticsCookies: 'Отклонить',
  navigateToSections: 'Перейти к разделам',
  backToPayment: 'Вернуться к оплате',
  paymentResultActionButton: 'Вернуться к задачам',
  toggleMenu: 'Развернуть или свернуть меню'
};
